import './App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Homepage from './pages/Homepage';

function App() {
  return (
    <>

    <Navbar />
    <Homepage />
    <Footer />

    </>
  );
}

export default App;
